const scrollToTop = (el: Element | undefined) => {
  if (!el) return;
  el.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export { scrollToTop };
